if ('ontouchstart' in document.documentElement) {
    $('body').attr('touch-enabled', true);
}
